<script setup>
import {computed} from "vue";

const props = defineProps(['need']);

const solutionsMatched = computed(() => {
    return props.need.solutions_liked_count >= 5;
})

const progressPerc = computed(() => {
    return 8 + Math.min(props.need.solutions_liked_count, 5) * 5.4;
})
</script>

<template>
    <div class="card card--need">
        <h5 class="heading5"><a :href="`/needs/${need.id}`" target="_blank">{{ need.name }}</a></h5>

        <div class="card--need__content">
            <div class="card--need__text">
                <p>{{ need.description }}</p>
            </div>

            <a v-if="need.solutions_new_count" :href="`/needs/${need.id}?openMatchMaking=1`" target="_blank" class="link-arrow">View New Matches</a>
        </div>

        <ul class="list-info">
            <li class="list-info__startup">{{need.solutions_liked_count + need.solutions_new_count}} Solutions</li>
        </ul>

        <div class="needs-stats">
            <div class="needs-stats__progress" :style="`width: ${progressPerc}%`"></div>
            <ul class="needs-stats__steps">
                <li class="needs-stats__steps__created needs-stats__steps__active">Need Created</li>
                <li class="needs-stats__steps__matched" :class="{'needs-stats__steps__active': solutionsMatched}">Solutions Matched</li>
                <li class="needs-stats__steps__reviewed">Solutions Reviewed</li>
                <li class="needs-stats__steps__escalated">Need Escalated</li>
            </ul>
        </div>
    </div>
</template>

<style scoped>

</style>
